"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentScheduleModal_1 = require("./PaymentScheduleModal");
exports.default = PaymentScheduleModal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/index.js
// module id = 2386
// module chunks = 8